import { Divider, Drawer } from "@material-ui/core";
import {
  Business,
  ClearAll,
  Description,
  FileCopy,
  List,
  People,
  Person,
  VpnKey,
  Assessment,
  MarkunreadMailbox,
  Money
} from "@mui/icons-material";//@material-ui/icons";
import { Calendar_today } from "@mui/icons-material";//@material-ui/icons/CalendarToday";
import { CalendarToday } from "@mui/icons-material";//@material-ui/icons/CalendarToday";
//err import { Calendar } from "@mui/icons-material";//@material-ui/icons/CalendarToday";
import { makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import Profile from "src/components/layouts/main/sidebar/Profile";
import SidebarNav from "src/components/layouts/main/sidebar/SidebarNav";

const Sidebar = (props) => {
  const { open, variant, onClose } = props;
  const classes = useStyles();

  const pages = [];

  pages.push(
    {
      title: "Kalendář",
      href: "/calendar",
      icon: <CalendarToday />,
      //icon: <Calendar />,
      authority: "calendar.view"
    },
    {
      title: "Zákazníci",
      href: "/customer-management",
      icon: <Person />,
      authority: "customer.view"
    },
/*    {
      title: "Seznam barev",
      href: "/color-management",
      icon: <Person />,
      authority: "color.view"
    },*/

    {
      title: "Správa poukazů",
      href: "/voucher-management",
      icon: <Description />,
      authority: "voucher.view"
    },
/*    {
      title: "Správa permanentek",
      href: "/pass-log-management",
      icon: <VpnKey />,
      authority: "passlog.view"
    },*/
    {
      title: "Sumarizace",
      href: "/sum-management",
      icon: <Assessment />,
      authority: "companysum.view"
    },
    {
      title: "Správa uživatelů",
      href: "/user-management",
      icon: <People />,
      authority: "user.view"
    },
    {
      title: "Správa společnosti",
      href: "/company-management",
      icon: <Business />,
      authority: "company.view"
    },
    {
      title: "Správa automobilů",
      href: "/car-management",
      icon: <Business />,
      authority: "car.view"
    },
    {
      title: "Reporty",
      href: "/report-management",
      icon: <FileCopy />,
      authority: "report.view"
    },
    {
      title: "Pokročilé reporty",
      href: "/adv-report-management",
      icon: <MarkunreadMailbox />,
      authority: "all"
    },
    {
      title: "Správa ceníků",
      href: "/pricing-management",
      icon: <Money />,
      authority: "all"
    },
    {
      title: "Agenda",
      href: "/agenda",
      icon: <List />,
      authority: "agenda.view"
    },
    {
      title: "Agenda",
      href: "/cleaner-agenda",
      icon: <ClearAll />,
      authority: "cleaner.view"
    }
  );

  return (
    <Drawer anchor="left" classes={{ paper: classes.drawer }} onClose={onClose} open={open} variant={variant}>
      <div className={classes.root}>
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav pages={pages} onClose={onClose} />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up("lg")]: {
      marginTop: 64,
      height: "calc(100% - 64px)"
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  }
}));

export default Sidebar;
